// extracted by mini-css-extract-plugin
module.exports = {"scrollabe-container":"_3D4Kw9kj","scrollabeContainer":"_3D4Kw9kj","quarter":"_1d5pb45O","quint":"_1b1cAjhI"};